module.exports = __webpack_public_path__ + "2cab20f6e7e909cd98c91f5249a6028a.svg";